import {	
    HANDLE_DRAWER_TOGGLE,	
    SET_HEADER_TEXT,	
} from '../types';	

const initialState = {	
    mobileOpen: false,	
    headerText: ''	
}	

export default function(state = initialState, action){	
    switch(action.type){	
        case HANDLE_DRAWER_TOGGLE:	
            return {	
                ...state,	
                mobileOpen: !state.mobileOpen	
            };	
        case SET_HEADER_TEXT:	
            return {	
                ...state,	
                headerText: action.payload	
            }	

                default:	
                return state;	
    }	
} 